import React from "react";
import { useForm, FormProvider } from "react-hook-form";

import { $host } from "../../../../http";
import {HtmlContentRenderer} from "../../../../helpers";

const HWCard = ({data, idx, ...props}) => {
    const methods = useForm({
        defaultValues: null
    })
    const deleteQuestion = async () => {
        try {
            await $host.delete(`/api/teachers/questions/${data.id}`)
            props.handleDeletion()
        } catch (err) {
            console.log(err);
        }
    }

    return (<div className="w-full rounded-2xl">
        <div className="flex items-center justify-between bg-lavender-extra-light min-h-[50px] rounded-2xl  px-4">
            <div className="font-semibold">Задание №{idx+1}</div>
            <div>

                <div className="cursor-pointer" onClick={deleteQuestion}>
                    <svg width="16" height="19" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4.17969 18.3672C3.04688 18.3672 2.3125 17.6484 2.25781 16.5312L1.71094 5.16406H0.78125C0.46875 5.16406 0.195312 4.89844 0.195312 4.57031C0.195312 4.25 0.46875 3.98438 0.78125 3.98438H4.32812V2.78906C4.32812 1.65625 5.0625 0.96875 6.26562 0.96875H9.23438C10.4375 0.96875 11.1719 1.65625 11.1719 2.78906V3.98438H14.7422C15.0625 3.98438 15.3203 4.25 15.3203 4.57031C15.3203 4.89062 15.0625 5.16406 14.7422 5.16406H13.8047L13.2656 16.5234C13.2109 17.6406 12.4609 18.3672 11.3438 18.3672H4.17969ZM5.57031 2.86719V3.98438H9.92969V2.86719C9.92969 2.42188 9.61719 2.13281 9.14844 2.13281H6.35156C5.88281 2.13281 5.57031 2.42188 5.57031 2.86719ZM4.28906 17.1875H11.2188C11.6797 17.1875 12.0156 16.8594 12.0312 16.3906L12.5469 5.16406H2.9375L3.48438 16.3906C3.50781 16.8516 3.84375 17.1875 4.28906 17.1875ZM5.44531 15.8516C5.15625 15.8516 4.96094 15.6719 4.95312 15.3906L4.71875 7.03906C4.71094 6.76562 4.90625 6.57812 5.20312 6.57812C5.48438 6.57812 5.67969 6.75781 5.6875 7.03125L5.92969 15.3906C5.9375 15.6641 5.74219 15.8516 5.44531 15.8516ZM7.75781 15.8516C7.46094 15.8516 7.25781 15.6641 7.25781 15.3906V7.03906C7.25781 6.76562 7.46094 6.57812 7.75781 6.57812C8.05469 6.57812 8.26562 6.76562 8.26562 7.03906V15.3906C8.26562 15.6641 8.05469 15.8516 7.75781 15.8516ZM10.0781 15.8516C9.78125 15.8516 9.58594 15.6641 9.59375 15.3906L9.82812 7.03906C9.83594 6.75781 10.0312 6.57812 10.3125 6.57812C10.6094 6.57812 10.8047 6.76562 10.7969 7.03906L10.5625 15.3906C10.5547 15.6719 10.3594 15.8516 10.0781 15.8516Z" fill="#6446C3" fillOpacity="0.3" />
                    </svg>
                </div>
            </div>
        </div>
        <div className="text-[18px] text-blue-gray-60 font-medium py-8 px-6">
            <HtmlContentRenderer htmlContent={data.title ?? ''} disabledImages={data.type !== 'text'} photo_url={data.photo_url} />

            <div className="mt-8">
                <FormProvider {...methods}>
                    {
                        data.type === 'text' ? <div>
                            <p className="font-semibold">Правильный ответ:</p>
                            {data.correct_answer}
                        </div> :
                        <ul className="flex flex-col gap-2">
                            {data.options && data.options.map((answer, idx) => <li className={`list-disc list-inside ${idx === +data.correct_answer ? 'text-lavender font-semibold': ''}`}>{answer}</li>)}
                        </ul>
                    }
                </FormProvider>
            </div>
        </div>
    </div>)
}

export default HWCard